// extracted by mini-css-extract-plugin
export default {"card":"Card_card__1d4RB","surface":"Card_surface__f2kSZ","tile":"Card_tile__90+bJ","glass":"Card_glass__dhMTI","ink":"Card_ink__hcy6r"};